import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { ProductCostProvider } from '@helpers/hooks/pages/dashboard/productCost/productCost';

import Wrapper from '@components/Dashboard/ProductCost/Wrapper';
import NoAccess from '@components/common/core/Utils/NoAccess';

const ProductCost: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_product_cost_full_write_access ||
    accessManagementData?.group?.has_product_cost_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <ProductCostProvider>
      <Wrapper />
    </ProductCostProvider>
  );
};

export default ProductCost;
